import { createContext } from 'react';

/**
 * Aktiver Abschnitt eines `SectionedDialogContent` (Register-Modus). `null` =
 * kein Register-Kontext → `FormSection` zeigt sich immer. Getrennte Datei, damit
 * `FormSection` den Kontext lesen kann, ohne `SectionedModal` zu importieren
 * (vermeidet einen Import-Zyklus).
 */
export const ActiveSectionContext = createContext<string | null>(null);
